import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './core/services';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent {
    constructor(private readonly languageService: LanguageService) {
      this.languageService.initLanguage();
  }

  title = 'IDS IREDO';
}
